import styled from 'styled-components';
import { Table, Form, Button, Row } from 'react-bootstrap';
import { ToReadableDate } from '../../../utils';
import { useState, useRef } from 'react';
import { ClaimItemsGetService, ClaimDocumentsGetService } from '../../../domain';
import { PaginationComponent } from '.';
import { ClaimsGetService } from '../../../domain';
import Swal from 'sweetalert2';

const _ClaimsGetService = new ClaimsGetService();

const SubDescription = styled.div`
    font-size: 17px;
    font-weight: 300;
    padding: 5px 0px;
`;

const StyledSubmitButton1 = styled(Button)`
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: white;
    text-align: left;

    &:disabled {
        background-color: #808080;
        border-color: #808080;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    @media (min-width: 300px) and (max-width: 500px) {
        justify-content: center;
    }
`;

const TableContainer = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    padding: 0;
    margin: 0;
    width: 100%;
`;

const Title = styled.h1`
    font-size: 36px;
    font-weight: 700;
`;

export default function ShowClaimsView({ formData, setFormData, setLoading, claimTypes, docPerClaimTypes }) {
    const [hasSelectedClaim, setHasSelectedClaim] = useState(false);
    const claimsCheckboxesRef = useRef({});

    const processRef = (element, id) => {
        if (element) {
            claimsCheckboxesRef.current[id] = element;
            if (formData.selectedClaim === id) {
                claimsCheckboxesRef.current[id].checked = true;
            }else{
                claimsCheckboxesRef.current[id].checked = false;
            }
        }
    };

    const _ClaimItemsGetService = new ClaimItemsGetService();
    const _ClaimDocumentsGetService = new ClaimDocumentsGetService();

    const showClaimType = (id) => {
        const claimType = claimTypes.find((item) => item.id === id);

        return claimType;
    };

    const bindAvailableClaimDocuments = async (id) => {
        const documents = await _ClaimDocumentsGetService.execute({ id: id });
        return documents;
    };

    const bindClaimItems = async (id) => {
        const claimItems = await _ClaimItemsGetService.execute({ id });
        return claimItems;
    };

    const bindAvailableClaims = async (page) => {
        try {
            setLoading(true);
            const claims = await _ClaimsGetService.execute({
                id: formData?.selectedPolicy,
                page: page,
                claimsStaff: true
            });

            const setPayload = { ...formData, availableClaims: claims };

            // remove the selected claims in the payload and the claim | claim items | claim documents details
            delete setPayload.claimsPayload;
            delete setPayload.selectedClaim;

            // remove the checked claims
            Object.keys(claimsCheckboxesRef.current).forEach((key) => {
                claimsCheckboxesRef.current[key].checked = false;
            });

            console.log('setPayload: ', setPayload);

            setFormData(setPayload);

            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
        }
    };

    const handleClaimsSelection = async (event = null) => {
        try {
            if (!event) {
                const { customerDetails, ...policyCustomerDetails } = formData.availablePolicy.find(
                    (item) => item.id === formData.selectedPolicy
                );

                setFormData({
                    ...formData,
                    createNewClaim: true,
                    selectedClaim: 'create new claim',
                    claimsPayload: {
                        refId: formData.claimsPayload.refId,
                        refTable: formData.claimsPayload.refTable,
                        status: 'Pending',
                        customerDetails: {
                            ...customerDetails,
                            ...policyCustomerDetails
                        }
                    }
                });
                return;
            }

            setLoading(true);
            const claimItems = await bindClaimItems(event.id);
            const documents = await bindAvailableClaimDocuments(event.id);
            setLoading(false);

            // map the document details to the pulled document if theres any.
            const docPerClaimTypesFiltered = docPerClaimTypes.filter(
                (item) => item.mtnClaimTypeId === event.mtnClaimTypeId
            );
            console.log('docPerClaimTypes: ', docPerClaimTypes);

            const mappedDocuments = docPerClaimTypesFiltered.map((item) => ({
                ...item,
                attachedDocuments: documents.claimDocuments.filter(
                    (docItem) => docItem.mtnDocumentTypeId === item.mtnDocumentTypeId
                )
            }));
            console.log('mappedDocuments', mappedDocuments);
            console.log('documents', documents);

            setFormData({
                ...formData,
                selectedClaim: event.id,
                createNewClaim: false,
                claimsPayload: {
                    ...formData.claimsPayload,
                    ...event,
                    ...claimItems,
                    claimDocuments: mappedDocuments
                }
            });

            // check | uncheck the selected checkbox
            if (formData?.selectedClaim !== event.id) {
                Object.keys(claimsCheckboxesRef.current).forEach((key) => {
                    if (key !== event.id.toString()) {
                        claimsCheckboxesRef.current[key].checked = false;
                    } else {
                        claimsCheckboxesRef.current[key].checked = true;
                        setHasSelectedClaim(true);
                    }
                });
            } else {
                setFormData({
                    ...formData,
                    selectedClaim: null,
                    createNewClaim: false
                });
                setHasSelectedClaim(false);

                Object.keys(claimsCheckboxesRef.current).forEach((key) => {
                    if (key === event.id.toString()) {
                        claimsCheckboxesRef.current[key].checked = false;
                    }
                });
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
        }
    };

    return (
        <div>
            <br />

            <Row>
                <Title>Claim</Title>
            </Row>

            <TableContainer>
                <Table bordered hover>
                    <thead className="text-center">
                        <tr>
                            <th></th>
                            <th>Acknowledgement Reference No.</th>
                            <th>Nature of Loss</th>
                            <th>Incident Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {formData?.availableClaims?.claims &&
                            claimTypes &&
                            formData.availableClaims?.claims.map((item, index) => {
                                return (
                                    <tr key={'policyItem_' + index}>
                                        <td className="text-center">
                                            <Form.Check
                                                className="checkbox"
                                                style={{ margin: '3px 5px 0px 7px' }}
                                                type="checkbox"
                                                name="agreed"
                                                ref={(el) => processRef(el, item.id)}
                                                onClick={() => handleClaimsSelection(item)}
                                            ></Form.Check>
                                        </td>
                                        <td>{item.refNo}</td>
                                        <td>{showClaimType(item.mtnClaimTypeId)?.claimTypeDesc}</td>
                                        <td>{ToReadableDate(item.incidentDate)}</td>
                                        <td>{item.status}</td>
                                    </tr>
                                );
                            })}
                        {!formData?.availableClaims?.claims?.length && (
                            <tr className="text-center">
                                <td colSpan="7">No claims available.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                {formData?.availableClaims?.totalData > 5 && (
                    <ButtonContainer>
                        <PaginationComponent
                            totalPage={formData?.availableClaims?.totalPage}
                            currentPage={formData?.availableClaims?.currentPage}
                            onPageChange={bindAvailableClaims}
                        />
                    </ButtonContainer>
                )}
            </TableContainer>
        </div>
    );
}
